import React from 'react';
import { ItemListName } from '../google-analytics/tracking';

export type ListContextTypes = {
  listName: ItemListName;
};

export const ListContext = React.createContext<ListContextTypes>({ listName: null });
